import Pagination from '../../../../components/checkListV2/pagination';

const Footer = ({
  totalPages = 0,
  currentPage = 0,
  setCurrentPage = () => {},
  serverAppTheme = {},
}) => {
    
  return (
    <div className='d-flex justify-content-center align-items-center p-0'>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
        serverAppTheme={serverAppTheme}
      />
    </div>
  );
};

export default Footer;
